import React, { Component, useContext, useEffect } from "react";
import { useHistory, Link, NavLink } from "react-router-dom";
import Sidebar from "./Sidebar";
import { AppContext } from "../../../Context/AppContext";
function Layout(props) {
  const history = useHistory();
  const appData = useContext(AppContext);
  // function handle_logout() {
  //   Logger.log(0, "Signout", "Signed Out");
  //   AuthManager.logoutUser();
  //   history.replace("/login");
  // }

  // function get_logged_User_name() {
  //   let userobj = null;
  //   if (AuthManager.isAuthenticated()) userobj = AuthManager.getAuthUser();
  //   if (
  //     userobj === null ||
  //     userobj === undefined ||
  //     userobj.profile === null ||
  //     userobj.profile === undefined
  //   )
  //     return "guest";
  //   return userobj.profile.first_name + " " + userobj.profile.last_name;
  // }
  useEffect(() => {
    if (!appData.pm.checkPermission("gmssettings_edit")) {
      history.push("/workspace/module/permission/denied");
    }
  }, []);
  return (
    <React.Fragment>
      <Sidebar />

      <main className="page-content h-100">{props.children}</main>
    </React.Fragment>
  );
}

export default Layout;
